// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Container, Space, Text } from '@mantine/core';
import { useContext } from 'react';
import AnnoucementsBox from '../../Molecules/Announcements/AnnouncementsBox';
import { ContactContext } from '../../Service/Context/ContactContext';
import Onboarding from '../Onboarding/Onboarding';
import { EventsContext } from '../../Service/Context/EventsContext';

const WelcomeHeader = () => {
  const {
    contact: { firstName },
  } = useContext<any>(ContactContext);

  const { view } = useContext(EventsContext);

  return (
    <Container px={0} size={800}>
      <Onboarding />
      {view === 'list' && (
        <>
          <Space h="xs" />
          <Text size="xl" weight="bolder">
            {`Moin ${firstName}! `}&#128075;
          </Text>
          <AnnoucementsBox />
          <Space h="sm" />
        </>
      )}
    </Container>
  );
};

export default WelcomeHeader;
